// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2jDk2","box":"WorkspacesBox_box__2c59p","node":"WorkspacesBox_node__3hhh5"};